require("@rails/ujs").start()
require("channels")
require('jquery')

import Alpine from 'alpinejs'
import Filesize from "filesize"

import 'style/application.css'

// Stimulus Setup
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)

application.load(definitionsFromContext(context))

import 'style/tailwind.css'

// =========================
//    AlpineJS Components
//==========================
import fileUploader from '../components/file_uploader.js';
import repeatableBoardSeatEntry from '../components/repeatable_board_seat_entry.js';

Alpine.data('fileUploader', fileUploader);
Alpine.data('repeatableBoardSeatEntry', repeatableBoardSeatEntry);

window.Alpine = Alpine
window.filesize = Filesize

Alpine.start()
